export const captureTicker = (ticker, quickViewState) => {
  if (!ticker) return undefined;

  const newQuickViewState = { ...quickViewState };
  newQuickViewState[ticker] = !newQuickViewState[ticker];
  return newQuickViewState;
};

export const isNumber = number => Number.isInteger(number);
